const Paperclip = () => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.5 2C11.0147 2 9 4.01472 9 6.5V15.5C9 16.8807 10.1193 18 11.5 18C12.8807 18 14 16.8807 14 15.5V7.5C14 7.22386 13.7761 7 13.5 7C13.2239 7 13 7.22386 13 7.5V15.5C13 16.3284 12.3284 17 11.5 17C10.6716 17 10 16.3284 10 15.5V6.5C10 4.567 11.567 3 13.5 3C15.433 3 17 4.567 17 6.5V15.5C17 18.5376 14.5376 21 11.5 21C8.46243 21 6 18.5376 6 15.5V10.5C6 10.2239 5.77614 10 5.5 10C5.22386 10 5 10.2239 5 10.5V15.5C5 19.0899 7.91015 22 11.5 22C15.0899 22 18 19.0899 18 15.5V6.5C18 4.01472 15.9853 2 13.5 2Z"
      fill="#7A7A83"
    />
  </svg>
)

export default Paperclip
